// src/WayneAIPlatformFrontend/src/hooks/useStreamingBuffer.ts
import { useChatStream } from '@/stores/chatStream.store';
import type { StreamingMessage } from '@/stores/chatStream.store';
import type { AgentId } from '@/services/ws/types';

export function useStreamingBuffer(agentId: AgentId): StreamingMessage | undefined {
  return useChatStream((s) => s.streamingByAgentId[agentId]);
}
